module.exports = __webpack_public_path__ + "static/media/icon-heart.f603174e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-heart.svg
// module id = 1225
// module chunks = 19